import { usePlausible as useCustomPlausible } from '../components/PlausibleProvider';

/**
 * Custom hook to use Plausible Analytics events
 * @returns The Plausible event tracking function
 */
export const usePlausible = () => {
  return useCustomPlausible();
}; 